import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      lastContainer: null
    }
  },
  computed: {
    ...mapGetters('checkout/mnpData', [
      'providerKey',
      'active'
    ]),
    ...mapGetters('checkout/tariff', [
      'selectedAboOptionId',
      'selectedTariff',
      'defaultTariff'
    ]),
    ...mapGetters('promotion', [
      'presalesInclusivePromotionsForFilterSet',
      'presalesInclusivePromotionsForContextAndTariff',
      'presalesInclusivePromotionsForContext'
    ]),
    ...mapGetters('promotion/promoCode', [
      'couponRedeemed',
      'validPromoCode',
      'codePromotions',
      'couponTypeCredit',
      'couponTypeVolume',
      'couponTypeStartingBonus',
      'couponDiscountAmount',
      'couponVolumeAmount',
      'couponVolumeUnit',
      'couponLimited',
      'voucherItem',
      'couponDuration'
    ]),
    // filter promotions - only those that match our criteria are taken into account
    appliedPromotions: function () {
      if (this.position !== 'fixed') {
        return this.appliedPromotionForPosition
      }
      if (this.effectiveTariff) {
        return this.presalesInclusivePromotionsForContextAndTariff(this.context, this.effectiveTariff.tariffId)
      }
      return this.presalesInclusivePromotionsForContext(this.context)
    },
    // filter promotions for a special position
    appliedPromotionForPosition: function () {
      // TODO: implement position filter logic. to begin with, use all for context
      return this.presalesInclusivePromotionsForFilterSet({
        context: this.context,
        tariffId: this.effectiveTariff?.tariffId || null,
        tariffOptionId: this.selectedAboOptionId,
        position: this.position,
        mnpProvider: this.providerKey
      })
    },
    // for all applied promotions, we extract the applied incentives
    // e.g. a promotion with an volume incentive (+1GB Data) is active for our tariff
    // but this component should show price discount, the 1GB Data does not apply to our component
    appliedIncentives: function () {
      return this.appliedPromotions.map(promo => {
        return (promo.incentives || []).map(incentive => {
          return {
            ...incentive,
            mnpProvider: promo.criteria?.mnpProvider || [],
            tariffOptionIds: promo.criteria?.tariffoptionIds || [],
            limited: promo.limited,
            duration: promo.duration,
            requiredParameters: promo.requiredParameters
          }
        })
      })
        .reduce((prev, current) => [...prev, ...current], [])
        .filter(incentive => incentive.requiredParameters === null)
        .filter(incentive => incentive.mnpProvider.length === 0 || (this.active && this.compareProviderKeys(incentive.mnpProvider, this.mnpProviderKeyList)))
        .filter(incentive => {
          if (this.limitIncentivesBySelectedTariffoption) {
            const tariffOptionIds = incentive.tariffOptionIds
            if (tariffOptionIds.length > 0 && !tariffOptionIds.includes(this.selectedAboOptionId)) {
              return false
            }
            return true
          }
          return true
        })
        .filter(incentive => this.applicableIncentiveTypes.length === 0 || this.applicableIncentiveTypes.includes(incentive.type))
        .filter(incentive => this.getLimitedIncentiveTypes.length === 0 || this.getLimitedIncentiveTypes.includes(incentive.limited))
    },
    // default behaviour: defined via prop so it can be filtered by context
    // if your component only supports a specific incentive type (e.g "stroke price" only supports credit discount)
    // overwrite this in your component and only return array of supported types
    applicableIncentiveTypes: function () {
      return this.incentiveTypes
    },
    getLimitedIncentiveTypes: function () {
      return [true, false]
    },
    limitIncentivesBySelectedTariffoption: function () {
      return true
    },
    // if we have at least one incentive that can be applied to this component, we decide to be on acitve promotion state
    promotionActive: function () {
      // IMPORTANT!
      // IMPORTANT!
      // some components like provider select are used in multiple processes
      // e.g checkout, activation, belated porting
      // currently we have only promotions planned for checkout and magma
      // does not yet provide information for which process an activation is used
      // to ensure to only apply changes on checkout, we do an workaround here
      // and deactivate for activation and belatedPorting
      // IMPORTANT!
      // IMPORTANT!
      if (['belatedPorting'].includes(this.frontendContext)) {
        return false
      }
      return this.appliedIncentives.length > 0
    },
    // helper functions to filter incentives for our component
    creditIncentives: function () {
      return (this.appliedIncentives || []).filter(incentive => incentive.type === 'credit')
    },
    volumeIncentives: function () {
      return (this.appliedIncentives || []).filter(incentive => incentive.type === 'volume')
    },
    effectiveTariff: function () {
      if (this.tariff) {
        return this.tariff
      }
      if (this.active && this.selectedTariff && (this.selectedTariff.tariffId === '162' || this.selectedTariff !== this.defaultTariff)) {
        return this.selectedTariff
      }
      if (!this.active && this.defaultTariff) {
        return this.defaultTariff
      }
      if (this.active) {
        return { tariffId: ['152'] }
      }
      if (this.rawTariff) {
        return JSON.parse(this.rawTariff)
      }
      return null
    },
    // overwrite in component if there is a reason not to do it (e.g. feature flag)
    outsideActive: function () {
      return true
    },
    // overwrite in component if limited promotion/incencitive displayed
    limited: function () {
      return false
    },
    getAppliedIncentivesWithProviders: function () {
      return this.appliedIncentives ? this.appliedIncentives.filter(incentive => { return incentive.mnpProvider?.length > 0 }) : []
    },
    // overwrite in component if different provider filter is needed
    mnpProviderKeyList: function () {
      return [this.providerKey]
    },
    // overwrite in component if different condition is needed
    hasMNPPromo: function () {
      return this.promotionActive && this.getAppliedIncentivesWithProviders.length > 0
    }
  },
  methods: {
    markParent: function (active) {
      const promoContainer = this.$el?.closest?.(this.markSelector) || this.lastContainer
      if (!promoContainer) return
      this.lastContainer = promoContainer
      if (active && this.outsideActive) {
        promoContainer.classList.add(`has-promo-${this._uid}`)
      } else {
        promoContainer.classList.remove(`has-promo-${this._uid}`)
      }

      if (active && this.outsideActive && this.limited) {
        promoContainer.classList.add(`has-limited-promo-${this._uid}`)
      } else {
        promoContainer.classList.remove(`has-limited-promo-${this._uid}`)
      }
    },
    // this method marks every container in markOtherContainerSelectors by adding className
    markOtherContainer (active, className) {
      const selectorsArray = this.markOtherContainerSelectors.split(',')

      if (Array.isArray(selectorsArray) === true && selectorsArray.length > 0) {
        selectorsArray.forEach(selector => {
          const otherContainer = document.getElementsByClassName(selector)
          if (typeof otherContainer[0] !== 'undefined') {
            if (active) {
              otherContainer[0].classList.add(className)
            } else {
              otherContainer[0].classList.remove(className)
            }
          }
        })
      }
    },
    compareProviderKeys (mnpProvider, providerKeyList) {
      return mnpProvider.some(providerKey => (providerKeyList.includes(providerKey)))
    },
    setMNPPromoClass (promoClass) {
      const body = document.getElementById('top')
      const isClassSet = body.classList.contains(promoClass)
      if (this.hasMNPPromo) {
        if (!isClassSet) {
          body.classList.add(promoClass)
        }
      } else if (isClassSet) {
        body.classList.remove(promoClass)
      }
    }
  },
  mounted () {
    const comp = this
    this.$nextTick(() => {
      comp.markParent(comp.promotionActive)
    })
  },
  watch: {
    promotionActive: {
      immediate: true,
      handler: function (value) {
        this.markParent(value)
      }
    },
    outsideActive: {
      immediate: true,
      handler: function (val) {
        const comp = this
        this.$nextTick(() => {
          comp.markParent(comp.promotionActive)
        })
      }
    }
  },
  props: {
    position: {
      type: String,
      default: 'fixed'
    },
    context: {
      type: String,
      required: true
    },
    frontendContext: {
      type: String
    },
    tariff: {
      type: Object
    },
    incentiveTypes: {
      type: Array,
      default: () => []
    },
    // Query Selector for parent element that should be marked when promo is active
    markSelector: {
      type: String,
      default: '.promo-container'
    },
    markOtherContainerSelectors: {
      type: String,
      default: '.promo-container' // if multiple selectors separate them with commas without space like "first-selector,second-selector
    }
  }
}
